import LocationsCountBox from "./LocationsCountBox";

export default LocationsCountBox;
